import styled from "@emotion/styled";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";

export const StyledLabel = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
    display: "block",
}));

export const StyledGrid = styled(
    Box,
    {
        shouldForwardProp: (prop) => prop !== "singleItem",
    }
)<{ singleItem?: boolean }>(({ theme, singleItem }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(1),
    ...(
        singleItem && {
            "> *": {
                gridColumn: "1 / -1", // Make single item span full width
            },
        }
    ),
}));

export const StyledTemplateItem = styled(
    Box,
    {
        shouldForwardProp: (prop) => prop !== "isSelected",
    }
)<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
    display: "flex",
    borderRadius: theme.kaltura.shape.roundness2,
    cursor: "pointer",
    border: `2px solid ${isSelected ? theme.palette.primary.main : "transparent"}`, // Double border technique: outer border for selection state (2px)
    boxShadow: isSelected ? "none" : `inset 0 0 0 1px ${theme.kaltura.palette.tone4}`, // inner border (via boxShadow) for constant outline (1px)
    "&:focus-visible": VisibleFocusStyle,
    padding: theme.spacing(2),
    gap: theme.spacing(0.5),
    "& > svg": {
        minWidth: "90px",
    },
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        flexDirection: "column",
        alignItems: "center",
        "& > svg": {
            minWidth: "72px",
        },
    },
}));

export const StyledTemplateText = styled("div")(({ theme }) => ({
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        textAlign: "center",
    },
}));
